<template>
    <div class="pa-3 grey lighten-4">
        <v-card>
            <!-- Uploading Link -->
            <template>
                <v-card-title class="grey lighten-4">
                    <h3 class="secondary--text">{{ $t("screener.avails.right_holder.heading") }}</h3>
                    <v-spacer></v-spacer>
                    <v-btn color="success" @click="$emit('onSave',film)" small>Save</v-btn>
                </v-card-title>
                <UploadingLink :film="film" :company="company"/>
            </template>
        </v-card>
        <!-- Rightholder Revenue share -->

        <v-card class="mt-3">
        <v-card-title class="grey lighten-4">
            <h3 class="secondary--text">{{$t('screener.avails.revenue_share.title')}}</h3>
            <v-spacer></v-spacer>
            <v-btn color="success" @click="$emit('onSave',film)" small>Save</v-btn>
        </v-card-title>
        <v-card-text>
            <MediaRevenueShare
            :film.sync="film"
            :company="company"
            ref="mediaRevenueShare"
            ></MediaRevenueShare>
        </v-card-text>
        </v-card>

    </div>
</template>
<script>
import { mapState } from "vuex";
import UploadingLink from "@/components/UploadingLink";
import MediaRevenueShare from "@/components/media/RevenueShareForm";
export default {
    name: "FilmRightHolder",
    props: {
        film: {
            type: Object,
            default: null
        }
    },
    components: {
        UploadingLink,
        MediaRevenueShare
    },
    computed: {
        ...mapState({
            company: state => state.company.company,
        }),
    }
}
</script>
